import { useMutation } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { enqueueSnackbar } from 'notistack';

import { axiosClient } from '@/services/BaseApi.service';

import type { SendTestEmailRequest } from './EmailSubjectTemplate.types';

export const useSendTestEmail = () => {
  return useMutation({
    mutationFn: (request: SendTestEmailRequest) =>
      axiosClient.post(
        `/organization_settings/${request.organization_label}/test_email_subject`,
        {
          email: request.email,
          action: request.action
        }
      ),
    onSuccess: () => {
      enqueueSnackbar('Test email sent successfully', {
        variant: 'success'
      });
    },
    onError: (err: AxiosError<{ detail: string }>) => {
      enqueueSnackbar(
        err.response?.data?.detail || 'Failed to send test email',
        { variant: 'error' }
      );
    }
  });
};

export default useSendTestEmail;
